import React, { createContext, useState, useEffect } from 'react';
import { auth } from './firebase';

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [username, setUsername] = useState(null);
  const [uid, setUid] = useState(null);

  useEffect(() => {
    auth.onAuthStateChanged(async user => {
      setIsAuthenticated(!!user);
      setUsername(user ? user.email.split('@')[0] : null);

      if (user) {
        const idTokenResult = await user.getIdTokenResult();
        setIsAdmin(!!idTokenResult.claims.isAdmin);
        setUid(user.uid);
      } else {
        setIsAdmin(false);
      }
    });
  }, []);

  const logIn = async (username, password) => {
    const email = username + '@onlineapp.com.br';
    await auth.signInWithEmailAndPassword(email, password);
  };

  const value = {
    isAdmin,
    isAuthenticated,
    logIn,
    uid,
    username,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
